export default function PageHeader({ eyebrow, title, description, actions, testId }) {
    return (
        <div
            className="border-b border-slate-200 bg-white px-6 lg:px-10 py-7"
            data-testid={testId || "page-header"}
        >
            <div className="flex items-start justify-between gap-6 flex-wrap">
                <div className="min-w-0">
                    {eyebrow && (
                        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-2">
                            {eyebrow}
                        </div>
                    )}
                    <h1 className="font-display text-3xl lg:text-4xl font-bold text-slate-950 truncate">
                        {title}
                    </h1>
                    {description && (
                        <p className="text-sm text-slate-600 mt-2 max-w-2xl">
                            {description}
                        </p>
                    )}
                </div>
                {actions && <div className="flex items-center gap-2">{actions}</div>}
            </div>
        </div>
    );
}
